import { Button, Icon, TrashHollowSVG, useModal } from "@newsela/angelou";

import { Assignment } from "@/types/models/Assignment.interface";
import { StreamProperties } from "@/types/models/EventProperties.interface";
import ActionsDropdown from "@/view/ActionsDropdown";
import AssignmentDeleteModal from "@/view/AssignmentDeleteModal";
import { dropdownItemCss, iconCss } from "./DeleteAssignmentOption.style";

interface DeleteOption {
  updatedAssignment: Pick<
    Assignment,
    "assignment_members" | "content_id" | "is_draft"
  >;
  streamProperties: StreamProperties;
}

const DeleteAssignmentOption = ({
  updatedAssignment,
  streamProperties,
}: DeleteOption) => {
  const [
    deleteAssignmentModalProps,
    setIsDeleteAssignmentModalActive,
    triggerRef,
  ] = useModal(false);

  const assignmentMembers = updatedAssignment?.assignment_members;

  const closeDeleteModal = () => {
    setIsDeleteAssignmentModalActive(false);
  };

  const openDeleteModal = () => {
    setIsDeleteAssignmentModalActive(true);
  };

  const eventProperties = {
    objectType: "Assignment",
    actionPrefix: "Initiate",
    actionName: "Delete",
    streamProperties: {
      ...streamProperties,
      content_ids: assignmentMembers?.map((member) =>
        "content" in member ? member.content.content_id : member.content_id,
      ),
      description: "Open delete assignment modal.",
    },
  };

  return (
    <>
      <ActionsDropdown.ButtonItem
        __cssFor={{ Button: { root: dropdownItemCss } }}
        dataProps={{
          "data-qa-selector": "assignment-dropdown-delete-assignment",
          "data-testid": "assignment-dropdown-button",
        }}
        onClick={openDeleteModal}
        {...eventProperties}
      >
        <Icon
          __cssFor={{ root: iconCss }}
          size={Button.sizes.md}
          SvgComponent={TrashHollowSVG}
          title="Delete assignment"
        />
        Delete assignment
      </ActionsDropdown.ButtonItem>
      <AssignmentDeleteModal
        closeDeleteModal={closeDeleteModal}
        deleteAssignmentModalProps={deleteAssignmentModalProps}
        isDraftAssignment={updatedAssignment.is_draft}
        triggerRef={triggerRef}
      />
    </>
  );
};

export default DeleteAssignmentOption;
